module.exports = __webpack_public_path__ + "static/media/prof_pic.bcba47f8.JPG";